module.exports = __webpack_public_path__ + "img/0.a482b7dc.webp";